/**
 * index.customer.js
 *
 * @Author: wangyinan
 * @Date: 2018/3/29 下午2:58
 */
import 'neatui/es/scss/index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import CustomerService from './customerService/Index';
import createStore, { history } from './_index';
import createRootReducer from './reduxModules/customerReducer';
import * as serviceWorker from './serviceWorker';
import { hot } from 'react-hot-loader';

window.platformOfRuntime = {
  device: 'pc',
};

const App = hot(module)(() => <CustomerService />);
const store = createStore(createRootReducer(history), {});
ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
